import { Button, type ButtonProps } from '@mui/material';
import Link from 'next/link';

export const ViewDetailsButton = ({ sx, ...props }: ButtonProps) => {
  return (
    <Button
      LinkComponent={Link}
      variant="link"
      sx={{ py: 0.75, ...sx }}
      {...props}
    >
      View Details
    </Button>
  );
};
